export default function RegionSidebar({ regions }) {
  return (
    <aside className="sidebar">
      <ul>
        {Object.keys(regions).map(region => (
          <li key={region}>{region}</li>
        ))}
      </ul>
    </aside>
  );
}
